/**
 * Store registry for tracking stores that need to be cleared on logout.
 * This replaces unsafe access to Pinia internals (pinia._s).
 */

type ClearFunction = () => void

const registry = new Map<string, ClearFunction>()

/**
 * Register a store's clear function to be called on logout.
 * Called by storeResetPlugin for each store.
 */
export function registerStoreForLogout(storeId: string, clearFn: ClearFunction): void {
  registry.set(storeId, clearFn)
}

/**
 * Unregister a store (e.g., when store is disposed).
 */
export function unregisterStore(storeId: string): void {
  registry.delete(storeId)
}

/**
 * Clear all registered stores. Called during logout.
 */
export function clearAllStoresOnLogout(): void {
  registry.forEach((clearFn, storeId) => {
    try {
      clearFn()
    } catch (e) {
      console.error(`[StoreRegistry] Failed to clear store "${storeId}":`, e)
    }
  })
}

/**
 * Get count of registered stores (for debugging).
 */
export function getRegisteredStoreCount(): number {
  return registry.size
}
